import { Voice } from '../types/content'

/** First person, first name, age and stage. About being believed — never about weight lost. */
export const voices: Voice[] = [
  {
    quote:
      'I had spent two years convinced something was seriously wrong with my brain. The first appointment here, someone said the word perimenopause in the first four minutes. I cried in the car afterwards, out of relief.',
    name: 'Dani',
    age: 44,
    stage: 'Perimenopause',
  },
  {
    quote:
      'Four doctors. Three of them offered me an antidepressant without asking a single question about my cycle. Nobody had ever asked me how long my periods were.',
    name: 'Renata',
    age: 47,
    stage: 'Perimenopause',
  },
  {
    quote:
      'I did not know that sex hurting was a treatable medical thing. I thought it was the end of that part of my life and I was supposed to be quiet about it. It took eight weeks of a cream to undo.',
    name: 'Ji-woo',
    age: 56,
    stage: 'Post-menopause',
  },
  {
    quote:
      'What helped most was not even the prescription. It was reading a page that described my exact 3am, word for word, and realising I was not the only one awake.',
    name: 'Marguerite',
    age: 51,
    stage: 'Menopause',
  },
  {
    quote:
      'I was 38 and I was told to come back when I was older. I brought three months of cycle tracking to my Vesta consult and she said, this is textbook early perimenopause. I had been right the whole time.',
    name: 'Amara',
    age: 39,
    stage: 'Early signals',
  },
  {
    quote:
      'The circle is twelve women who all know what a rage morning is. I say less there than anyone. It still helps more than anything else I do all week.',
    name: 'Bev',
    age: 53,
    stage: 'Menopause',
  },
]
